import React from 'react';
import './OfferingsContent.css';
import Container from '@material-ui/core/Container';
// import OfferingsNavContent from './OfferingsNavContent';
import OfferingsTabContent from './OfferingsTabContent';
import { useLocation } from 'react-router-dom';

function OfferingsContent() {
    const location = useLocation();    
    return (
        <>
            <div className="main-container" id='main'>
                <title>L&TT Portal - Offerings</title>
                {/* <img src="images/Offerings/at-new-offerings-banner.jpg" alt="offerings banner" className='banner-img' /> */}
                <div className='bannerText-Wrapper'>
                <h1 role="heading" aria-level="1" className='bannerHeading' tabIndex={0}>L&TT <span>Offerings</span></h1>
                <p className='bannerSubheading'>Maximize excellence with a plethora of our innovative and ingenious offerings</p>
                </div>
            </div>
            <div className="banner-bar"></div>
            <div className="offerings-container-bg">
                <Container className='offerings-holder' maxWidth="xl">
                    <div className="offerings-container">
                        <div className="offerings-wrap">
                            <div className="offerings-row">
                                <div className="offerings-box">
                                    {/* <h2>Offerings</h2> */}
                                    <p>Explore L&TT's in-demand, innovative learning offerings aligned with ATCI’s overall business and growth strategy, providing immersive learning experiences to fulfill learning aspirations of our people.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="offeringstab-container">
                        <OfferingsTabContent menu1={location.menu1 ? location.menu1 : 'default'} menu2={location.menu2 ? location.menu2 : 'default'} menu3={location.menu3 ? location.menu3 : 'default'}/>
                    </div>
                    
                    {/* <div className="stay-container">
                        <div className="stay-wrap">
                            <div className="stay-row">
                                <div className="stay-box">
                                    <h2>Stay in the know</h2>
                                    <p>Enabling growth and change, making a meaningful impact for our people and business @ATCI</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="learncard-container">
                        <div className="learncard-wrap">
                            <div className="learncard-row">
                                <div className="learncard-box" >
                                    <img src="images/Offerings/LKM eCatalogs.png" alt="eCatalog" className='learncard-img' />
                                    <h3>LKM eCatalogs</h3>
                                    <p>A detailed view of LKM offerings across three categories: Technology, Delivery, and Innovation</p>
                                    <p><a href="https://atci.lkm.accenture.com/LKM-eCatalog/home" target="_blank">Explore More <img src="images/Offerings/Go Arrow.png" alt="" /></a></p>
                                </div>
                            </div>
                            <div className="learncard-row">
                                <div className="learncard-box">
                                    <img src="images/Offerings/LKM Calendar.png" alt="Calendar" className='learncard-img' />
                                    <h3>LKM Calendar</h3>
                                    <p>LKM's lateral calendarized learning program offerings on Technology, Delivery, and Innovation</p>
                                    <p><a href="https://atci.lkm.accenture.com/learning-calendar" target="_blank">Explore More <img src="images/Offerings/Go Arrow.png" alt=""  /></a></p>
                                    
                                </div>
                            </div>
                            <div className="learncard-row">
                                <div className="learncard-box" >
                                    <img src="images/Offerings/Learning Paths.png" alt="Paths" className='learncard-img' />
                                    <h3>Learning Paths - Specialization</h3>
                                    <p>Learning Paths to build increasing levels of competency and deep expertise</p>
                                    <p><a href="#">Explore More <img src="images/Offerings/Go Arrow.png" alt="" className='Arrow-img' /></a></p>
                                </div>
                            </div>
                        </div>
                        <div className="learncard-wrap">
                            <div className="learncard-row">
                                <div className="learncard-box" >
                                    <img src="images/Offerings/Events.png" alt="Events" className='learncard-img' />
                                    <h3>Learning Events</h3>
                                    <p>Hackathons, ideathons, and summits to stay updated on the latest tech advancements</p>
                                    <p><a href="#">Explore More <img src="images/Offerings/Go Arrow.png" alt="" className='Arrow-img' /> </a></p>
                                </div>
                            </div>
                            <div className="learncard-row" >
                                <div className="learncard-box" >
                                    <img src="images/Offerings/Digital Learnings.png" alt="Learnings" className='learncard-img' />
                                    <h3>Digital Learning Platforms</h3>
                                    <p>Established partnerships with leading global digital learning platforms for self-paced self-driven learning</p>
                                    <p><a href="#">Explore More <img src="images/Offerings/Go Arrow.png" alt="" className='Arrow-img' /></a></p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </Container>
            </div>
        </>
    )
}

export default OfferingsContent